var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomShoppingCart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 8.43c1.175 0 2.143.917 2.195 2.092l.086 1.814h1.59l-.329-5.772a.736.736 0 0 0-.725-.69H22.78V5.32c0-1.33-1.089-2.419-2.42-2.419a2.426 2.426 0 0 0-2.419 2.42v.535h-1.036a.724.724 0 0 0-.726.691l-.07 1.14-.034.726h1.452L21 8.431zm-1.59-3.11c0-.518.432-.95.95-.95.519 0 .951.432.951.95v.536h-1.9V5.32z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.701 12.336h1.089l.086-1.814a2.189 2.189 0 0 1 2.195-2.091h.553c0-.052 0-.018.034-.726-5.495 0-5.15-.017-5.305.034.19.312.346.657.432 1.037.294 1.175.847 3.3.916 3.56z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.134 25.745c0 1.21.985 2.195 2.194 2.195 1.21 0 2.195-.985 2.195-2.195s-.985-2.194-2.195-2.194c-1.21-.018-2.194.967-2.194 2.194zm2.194-.743a.73.73 0 0 1 .726.726.73.73 0 0 1-.726.726.73.73 0 0 1-.725-.726.73.73 0 0 1 .725-.726zM11.323 25.745c0 1.21.985 2.195 2.195 2.195s2.194-.985 2.194-2.195-.985-2.194-2.194-2.194c-1.21-.018-2.195.967-2.195 2.194zm2.195-.743a.73.73 0 0 1 .725.726.73.73 0 0 1-.725.726.73.73 0 0 1-.726-.726.73.73 0 0 1 .726-.726z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.9h-6.93a.724.724 0 0 0-.725.69l-.086 1.746h8.57l-.086-1.745A.75.75 0 0 0 21 9.9z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.147 13.805H11.064c.346 1.382 1.382 5.46 1.71 6.808h11.008c.38-.397.657-.898.795-1.469l1.279-4.423a.736.736 0 0 0-.709-.916z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.195 22.082h-10.49c-.639 0-1.192-.432-1.33-1.054a3.573 3.573 0 0 0-.104-.415c-.363-1.451-1.365-5.409-2.073-8.277a830.84 830.84 0 0 1-.812-3.214A2.2 2.2 0 0 0 6.26 7.463H3.893a.73.73 0 0 0-.726.726.73.73 0 0 0 .726.726H6.26c.328 0 .622.224.709.553 2.834 11.318 2.747 10.99 2.989 11.87a2.831 2.831 0 0 0 2.765 2.178H23.212a.73.73 0 0 0 .726-.726.754.754 0 0 0-.743-.708z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomShoppingCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-shopping-cart.e1497711fadc5185b5e1372f94536ab3.svg";